import { render, staticRenderFns } from "./ConfirmSubmitDialogNonBlockchain.vue?vue&type=template&id=01c3c0f7&"
import script from "./ConfirmSubmitDialogNonBlockchain.vue?vue&type=script&lang=js&"
export * from "./ConfirmSubmitDialogNonBlockchain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports